
import React, { useState, useEffect } from "react";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import DropDown2 from "../../../Pages/CreateQuestionsPaper/TestScheduling/Dropdwon-Shuffle";
import DropDown3 from "../../../Pages/CreateQuestionsPaper/TestScheduling/Drodpwon-Catch";
import MultiSelectSearchDropdown from "../../../Pages/CreateQuestionsPaper/SearchDropDown/MultiSelectSearchDropdown";
import SelectedDropdownValues from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import InputComponent from "../../../Components/Shared/FormInputs/FormInputs";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import Colors from "../../../Constants/Colors";
import TextEditor from "../../Landing/components/TextEditor";
import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
import { useNavigate } from "react-router-dom";

const BOOLEAN_OPTIONS = [
  { id: 1, label: "True" },
  { id: 0, label: "False" },
];

const ComputerBasedTestScheduling = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");

  // ── Test information ──────────────────────────────────────────────────────
  const [courses, setCourses] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState("");
  const [quesPaperList, setQuesPaperList] = useState([]);
  const [selectedQuesPaper, setSelectedQuesPaper] = useState(null);
  const [quesPaperDescription, setQuesPaperDescription] = useState("");
  const [paperSubjects, setPaperSubjects] = useState([]);

  // ── External client / flags (all default: not selected) ───────────────────
  const [isExternalClient, setIsExternalClient] = useState(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [generateProvisionalResult, setGenerateProvisionalResult] =
    useState(null);
  const [provisionSpotRegistrations, setProvisionSpotRegistrations] =
    useState(null);

  // ── Scope / Scope Reference / Group ───────────────────────────────────────
  const [scopes, setScopes] = useState([]);
  const [selectScope, setSelectedScope] = useState(null);
  const [scopeSpecificData, setScopeSpecificData] = useState([]);
  const [scopeSelection, setScopeSelection] = useState([]);
  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [studentGroupsLoading, setStudentGroupsLoading] = useState(false);
  const [studentGroupsError, setStudentGroupsError] = useState(null);

  // ── Test scheduling ───────────────────────────────────────────────────────
  const [testNameUserPart, setTestNameUserPart] = useState("");
  const [testDescription, setTestDescription] = useState("");
  const [numberOfSets, setNumberOfSets] = useState(null);
  const [testDateTime, setTestDateTime] = useState(null);
  const [time, setTime] = useState("");
  const [timeMinutes, setTimeMinutes] = useState("");
  const [shuffleSubjects, setShuffleSubjects] = useState(null);
  const [shuffleQuestions, setShuffleQuestions] = useState(null);
  const [shuffleOptions, setShuffleOptions] = useState(null);
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [serverCurrentTime, setServerCurrentTime] = useState(null);

  // ── Marking scheme ────────────────────────────────────────────────────────
  const [markingSchemeList, setMarkingSchemeList] = useState([]);
  const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState({});

  // ── Accordions ────────────────────────────────────────────────────────────
  const [bodyVisible, setBodyVisible] = useState(true);
  const [schedulingVisible, setSchedulingVisible] = useState(true);
  const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);

  // ── Client info (session storage fallback) ────────────────────────────────
  useEffect(() => {
    if (dataClient) {
      const info = dataClient?.client_schema_name?.[6]?.[0];
      sessionStorage.setItem("user_name", info?.user_name || "");
      sessionStorage.setItem("clientBranchId", info?.client_branch_id || null);
      sessionStorage.setItem("clientId", info?.client_id || null);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  const courseId = courseOpted
    ? typeof courseOpted === "object"
      ? courseOpted.id
      : courseOpted
    : null;

  // Scope / Scope Ref / Group enabled only when External Client = False
  const isExternalSelected =
    isExternalClient !== null && isExternalClient !== "";
  const isExternal = isExternalSelected && Number(isExternalClient) === 1;
  const scopeEnabled = isExternalSelected && Number(isExternalClient) === 0;

  const scopeId =
    selectScope && typeof selectScope === "object"
      ? selectScope.id
      : selectScope;
  const isScopeGroup = Number(scopeId) === 9;

  // ── Helpers ───────────────────────────────────────────────────────────────
  const showMessage = (text, img) => {
    if (setMessageBox) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{text}</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(img);
    }
  };

  const formatLocal = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const mins = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  // ── Server time ───────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-current-datetime/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const data = await response.json();
        if (data?.status === 200 && data?.data) {
          const { current_date, current_time } = data.data;
          setServerCurrentTime(`${current_date}T${current_time}`);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        setServerCurrentTime(new Date().toISOString());
      }
    };
    fetchServerTime();
  }, []);

  // server time + 15 min buffer
  const getCurrentDateTime = () => {
    const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
    base.setMinutes(base.getMinutes() + 15);
    return formatLocal(base);
  };

  // ── Courses ───────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
        showMessage(`Error fetching courses: ${error.message}`, ErrorImg);
      }
    };
    fetchCourses();
  }, []);

  // ── Scopes list ───────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchScopes = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-list-of-scopes`, {
          headers: { accept: "application/json" },
        });
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setScopes(data.filter((scope) => scope.status === 1));
      } catch (error) {
        console.error("Error fetching scopes:", error);
        showMessage(`Error fetching Scopes: ${error.message}`, ErrorImg);
      }
    };
    fetchScopes();
  }, []);

  // ── Scope reference options ───────────────────────────────────────────────
  useEffect(() => {
    const fetchScopeDetails = async () => {
      if (!scopeEnabled || scopeId === null || scopeId === undefined) {
        setScopeSpecificData([]);
        return;
      }
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-scopes-details-all`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.status === 200) {
          let apiData = data.data;
          if (Number(scopeId) === 1 && courseId) {
            apiData = apiData.filter((item) => item.course_id === courseId);
          }
          let scopeOptions = [];
          switch (Number(scopeId)) {
            case 1:
              scopeOptions = apiData.map((item) => ({
                id: item.batch_id,
                label: item.batch_name,
              }));
              break;
            case 2:
              scopeOptions = apiData.map((item) => ({
                id: item.branch_id,
                label: item.branch_name,
              }));
              break;
            case 3:
              scopeOptions = apiData.map((item) => ({
                id: item.city_zone_id,
                label: item.zone_name,
              }));
              break;
            case 4:
              scopeOptions = apiData.map((item) => ({
                id: item.city_id,
                label: item.city_name,
              }));
              break;
            case 5:
              scopeOptions = apiData.map((item) => ({
                id: item.state_id,
                label: item.state_name,
              }));
              break;
            case 7:
            case 8:
              scopeOptions = [{ id: 1, label: "All India" }];
              break;
            default:
              scopeOptions = [];
          }
          scopeOptions = Array.from(
            new Map(scopeOptions.map((opt) => [opt.id, opt])).values()
          );
          setScopeSpecificData(scopeOptions);
        } else {
          setScopeSpecificData([]);
        }
      } catch (error) {
        console.error("Error fetching scope details:", error);
        setScopeSpecificData([]);
      }
    };
    fetchScopeDetails();
  }, [scopeId, courseId, scopeEnabled]);

  // ── Student groups ────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;
      try {
        setStudentGroupsLoading(true);
        setStudentGroupsError(null);
        const resp = await fetch(
          `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsError("Not authenticated. Please login.");
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }
        const json = await resp.json();
        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        console.error("Error fetching student groups:", err);
        setStudentGroupsError(err.message || "Error");
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      } finally {
        setStudentGroupsLoading(false);
      }
    };
    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  useEffect(() => {
    setSelectedStudentGroup([]);
  }, [courseId]);

  const searchStudentGroups = (searchKey) => {
    let filtered = allStudentGroups;
    if (courseId) filtered = filtered.filter((g) => g.course_id === courseId);
    if (searchKey && searchKey.trim() !== "")
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    setStudentGroupsOptions(filtered);
  };

  const getFilteredStudentGroups = () => {
    if (!courseId) return studentGroupsOptions;
    return studentGroupsOptions.filter((g) => g.course_id === courseId);
  };

  // Group scope → scope reference not applicable
  useEffect(() => {
    if (isScopeGroup) setScopeSelection([]);
  }, [isScopeGroup]);

  // External client = true / not selected → clear scope, scope ref, group
  useEffect(() => {
    if (!scopeEnabled) {
      setSelectedScope(null);
      setScopeSelection([]);
      setSelectedStudentGroup([]);
    }
  }, [scopeEnabled]);

  // Clear client when External Client is not True
  useEffect(() => {
    if (!isExternal) setSelectedClient(null);
  }, [isExternal]);

  // ── Client list (external clients) ────────────────────────────────────────
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-cbt-client-list/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        if (result.status === 200 && Array.isArray(result.data)) {
          // id = client_name (unique, since some client_id values are null)
          setClientOptions(
            result.data.map((c) => ({
              id: c.client_name,
              label: c.client_name,
              client_id: c.client_id,
            }))
          );
        } else {
          setClientOptions([]);
        }
      } catch (error) {
        console.error("Error fetching client list:", error);
        showMessage(`Error fetching client list: ${error.message}`, ErrorImg);
      }
    };
    fetchClients();
  }, []);

  // ── Subjects by course ────────────────────────────────────────────────────
  useEffect(() => {
    const fetchSubjects = async () => {
      setSubjects([]);
      setSelectedSubject(null);
      setSelectedSubjectLabel("");
      setSelectedQuesPaper(null);
      if (!courseId) return;
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${courseId}`
        );
        const data = await response.json();
        setSubjects(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching subjects:", error);
        showMessage(`Error fetching subjects: ${error.message}`, ErrorImg);
      }
    };
    fetchSubjects();
  }, [courseId]);

  // ── Question paper list ───────────────────────────────────────────────────
  useEffect(() => {
    const fetchQuestionPaperList = async () => {
      setQuesPaperList([]);
      if (!clientBranchId || !courseId) return;
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-list/?branch_id=${clientBranchId}&course_id=${courseId}&class_id=10`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        if (result.status === 200) setQuesPaperList(result.data);
      } catch (error) {
        console.error("Error fetching question paper list:", error);
      }
    };
    fetchQuestionPaperList();
  }, [clientBranchId, courseId]);

  // ── Marking schemes ───────────────────────────────────────────────────────
  useEffect(() => {
    const fetchMarkingSchemes = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
          { headers: { accept: "application/json" } }
        );
        const result = await response.json();
        if (result.status_code === 200 || result.status === "success")
          setMarkingSchemeList(result.data);
      } catch (error) {
        console.error("Error fetching marking schemes:", error);
      }
    };
    fetchMarkingSchemes();
  }, []);

  // ── Instruction templates ─────────────────────────────────────────────────
  useEffect(() => {
    if (!userName || !clientBranchId) return;
    const fetchTestTemplates = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        setTestTemplates(await response.json());
      } catch (error) {
        console.error("Error fetching test templates:", error);
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  // ── Selected question paper → description + subjects/sections ─────────────
  useEffect(() => {
    const matchingPaper =
      selectedQuesPaper !== null
        ? quesPaperList.find(
            (paper) => Number(paper.ques_paper_id) === Number(selectedQuesPaper)
          )
        : null;

    if (!matchingPaper) {
      setQuesPaperDescription("");
      setPaperSubjects([]);
      setSelectedMarkingSchemes({});
      return;
    }

    setQuesPaperDescription(matchingPaper.description || "");
    const subjectsWithSections = Array.isArray(matchingPaper.subjects)
      ? matchingPaper.subjects.map((subject) => ({
          subject_id: subject.subject_id,
          subject_name: subject.subject_name,
          sections:
            Array.isArray(subject.sections) && subject.sections.length > 0
              ? subject.sections
              : [{ section_no: 1, section_name: "Section 1" }],
        }))
      : [];
    setPaperSubjects(subjectsWithSections);
    setSelectedMarkingSchemes({});
  }, [selectedQuesPaper, quesPaperList]);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleInputChange = (e) => {
    const minutes = e.target.value;
    setTime(minutes ? (minutes / 60).toFixed(2) : "");
    setTimeMinutes(minutes);
  };

  const handleTestDateTimeChange = (e) => setTestDateTime(e.target.value);

  // ── Save (create-cbt-schedule) ────────────────────────────────────────────
  const handleSave = async () => {
    const minAllowed = getCurrentDateTime();

    if (!courseId) return showMessage("Please select a Course.", ErrorImg);
    if (!selectedSubject)
      return showMessage("Please select a Subject.", ErrorImg);
    if (!selectedQuesPaper)
      return showMessage(
        "Question Paper must be selected. Please choose a valid question paper.",
        ErrorImg
      );

    if (!isExternalSelected)
      return showMessage("Please select External Client.", ErrorImg);

    if (isExternal && !selectedClient)
      return showMessage(
        "Please select a Client Name for an external client.",
        ErrorImg
      );

    // Scope / Scope Ref / Group validation (only when enabled)
    if (scopeEnabled) {
      const scopeSelectionFilled = Array.isArray(scopeSelection)
        ? scopeSelection.length > 0
        : !!scopeSelection;
      const studentGroupFilled = Array.isArray(selectedStudentGroup)
        ? selectedStudentGroup.length > 0
        : !!selectedStudentGroup;

      if (isScopeGroup) {
        if (!studentGroupFilled)
          return showMessage(
            'Please select at least one Student Group when Scope is set to "Group".',
            ErrorImg
          );
      } else if (!scopeSelectionFilled && !studentGroupFilled) {
        return showMessage(
          "Please select at least one Scope Reference OR a Student Group. Both cannot be empty.",
          ErrorImg
        );
      }
    }

    if (!testDateTime)
      return showMessage("Please select a Test Date Time.", ErrorImg);
    if (testDateTime < minAllowed)
      return showMessage(
        "Test date time must be at least 15 minutes from current time. Please correct it before saving.",
        ErrorImg
      );

    const durationMins = parseInt(timeMinutes, 10);
    if (!durationMins || durationMins <= 0)
      return showMessage(
        "Please enter a valid Duration (in minutes).",
        ErrorImg
      );

    const missingFields = [];
    if (!testNameUserPart.trim()) missingFields.push("Test Name");
    if (!testDescription.trim()) missingFields.push("Description");
    if (!instructionsHtml.trim()) missingFields.push("Instructions");
    if (missingFields.length > 0)
      return showMessage(
        `Please fill in all required fields: ${missingFields.join(", ")}.`,
        ErrorImg
      );

    const courseName =
      courses.find((c) => c.course_id === courseId)?.course_name || "";
    const quesPaperName =
      quesPaperList.find(
        (qp) => Number(qp.ques_paper_id) === Number(selectedQuesPaper)
      )?.ques_paper_name || "";

    // ms_id_sec_a..d (unused sections = null)
    const subjectsPayload = paperSubjects.map((subject) => {
      const ms = {
        ms_id_sec_a: null,
        ms_id_sec_b: null,
        ms_id_sec_c: null,
        ms_id_sec_d: null,
      };
      subject.sections.forEach((section, idx) => {
        const key = String.fromCharCode(97 + idx);
        if (["a", "b", "c", "d"].includes(key)) {
          ms[`ms_id_sec_${key}`] = selectedMarkingSchemes[key] || null;
        }
      });
      return {
        subject_id: subject.subject_id,
        subject_name: subject.subject_name,
        marking_scheme: [ms],
      };
    });

    const toIdArray = (list) =>
      (Array.isArray(list) ? list : list ? [list] : [])
        .map((s) => (typeof s === "object" ? s.id : s))
        .filter((v) => v !== null && v !== undefined);

    const batchIds =
      scopeEnabled && Number(scopeId) === 1 ? toIdArray(scopeSelection) : [];
    const studentGroupIds = scopeEnabled
      ? toIdArray(selectedStudentGroup)
      : [];

    const selectedClientObj = clientOptions.find(
      (c) => c.id === selectedClient
    );

    const body = {
      ques_paper_id: Number(selectedQuesPaper),
      is_external_client: isExternal,
      cbt_client_id: isExternal
        ? selectedClientObj?.client_id ?? null
        : clientId
        ? Number(clientId)
        : null,
      client_name: isExternal ? selectedClient || null : null,
      course_name: courseName,
      test_date_time: `${testDateTime}:00`,
      test_name: testNameUserPart.trim(),
      question_paper_name: quesPaperName,
      generate_provisional_result: Boolean(Number(generateProvisionalResult)),
      provision_spot_registrations: Boolean(
        Number(provisionSpotRegistrations)
      ),
      duration_mins: durationMins,
      no_of_sets: numberOfSets || 1,
      instructions_html: instructionsHtml || null,
      created_by: userName || "",
      subjects: subjectsPayload,
      cbt_centre_id: null,
      centre_names: ["NA"],
      batch_id: batchIds.length ? batchIds : null,
      student_group_id: studentGroupIds.length ? studentGroupIds : null,
      status: 1,
      cancel_reason: null,
      student_list: null,
    };

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/create-cbt-schedule/?shuffle_ques=${!!shuffleQuestions}&shuffle_subject=${!!shuffleSubjects}&shuffle_option=${!!shuffleOptions}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(body),
        }
      );
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.status === 400) {
        showMessage(
          data.message ||
            (typeof data.detail === "string" ? data.detail : "") ||
            `HTTP error! status: ${response.status}`,
          ErrorImg
        );
        return;
      }
      showMessage(
        data.message || "CBT schedule created successfully!",
        SuccessImg
      );
      setTimeout(() => navigate("/cbt_dashboard"), 1000);
    } catch (error) {
      showMessage(`Error creating CBT schedule: ${error.message}`, ErrorImg);
    }
  };

  const toggleBodyVisible = () => setBodyVisible(!bodyVisible);
  const toggleSchedulingVisible = () =>
    setSchedulingVisible(!schedulingVisible);
  const toggleMarkingSchemeVisible = () =>
    setMarkingSchemeVisible(!markingSchemeVisible);

  // Question papers filtered by the chosen subject
  const filteredQuesPapers = quesPaperList.filter(
    (qp) =>
      !selectedSubject ||
      !Array.isArray(qp.subjects) ||
      qp.subjects.some((s) => Number(s.subject_id) === Number(selectedSubject))
  );

  return (
    <>
      <div className="create-role-container">
        <div className="create-role-container-ques-paper-del">
          <span className="create-role-heading">CBT Scheduling</span>
          <div className="cr-header-btn-container">
            <button
              className="cr-cancel-btn"
              onClick={() => navigate(`/cbt_dashboard`)}
            >
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={handleSave}>
              SAVE
            </button>
          </div>
        </div>

        {/* ───────────── TEST INFORMATION ───────────── */}
        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>TEST INFORMATION</label>
            </div>
            <div className="accordion-btn" onClick={toggleBodyVisible}>
              {bodyVisible ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>
          {bodyVisible && (
            <div className="accordion-content">
              <div
                className="grid-container"
                style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
              >
                <div className="item3">
                  <SelectedDropdownValues
                    label="Course"
                    style={{ width: "100%" }}
                    setSelected={setCourseOpted}
                    selected={courseOpted}
                    options={courses.map((course) => ({
                      label: course.course_name,
                      id: course.course_id,
                    }))}
                    isRequired={true}
                  />
                </div>
                <div className="item-subject">
                  <DropDown
                    label="Subject"
                    style={{ width: "100%" }}
                    selected={selectedSubject}
                    setSelected={setSelectedSubject}
                    selectedLabel={selectedSubjectLabel}
                    setSelectedLabel={setSelectedSubjectLabel}
                    options={subjects.map((subject) => ({
                      label: subject.subject_name,
                      id: subject.subject_id,
                    }))}
                    isRequired={true}
                  />
                </div>
                <div className="item-001">
                  <DropDown
                    label="Question Paper Name"
                    style={{ width: "100%" }}
                    selected={selectedQuesPaper}
                    setSelected={setSelectedQuesPaper}
                    options={filteredQuesPapers.map((qp) => ({
                      label: qp.ques_paper_name,
                      id: qp.ques_paper_id,
                    }))}
                    isRequired={true}
                  />
                </div>
                <div className="item6">
                  <InputComponent
                    label="Question Paper Description"
                    style={{ width: "100%" }}
                    value={quesPaperDescription}
                    isRequired={false}
                    disable={true}
                  />
                </div>

                <div className="item-ext">
                  <DropDown
                    label="External Client"
                    style={{ width: "100%" }}
                    selected={isExternalClient}
                    setSelected={setIsExternalClient}
                    options={BOOLEAN_OPTIONS}
                    isRequired={true}
                  />
                </div>

                <div
                  className="item-client"
                  style={{
                    opacity: isExternal ? 1 : 0.5,
                    pointerEvents: isExternal ? "auto" : "none",
                  }}
                >
                  <DropDown
                    label="Client Name"
                    style={{ width: "100%" }}
                    selected={selectedClient}
                    setSelected={setSelectedClient}
                    options={clientOptions}
                    isRequired={isExternal}
                  />
                </div>

                {/* Scope */}
                <div
                  className="item-scope"
                  style={{
                    opacity: scopeEnabled ? 1 : 0.5,
                    pointerEvents: scopeEnabled ? "auto" : "none",
                  }}
                >
                  <DropDown3
                    label=" DS Scope"
                    style={{ width: "100%" }}
                    selected={selectScope}
                    setSelected={(value) => {
                      setSelectedScope(value);
                      setScopeSelection([]);
                    }}
                    options={scopes.map((scope) => ({
                      label: scope.ques_paper_scope_desc,
                      id: scope.ques_paper_scope_id,
                    }))}
                    isRequired={false}
                    disabled={!scopeEnabled}
                  />
                </div>

                {/* Scope Reference */}
                <div className="item-scope-ref">
                  <MultiSelectSearchDropdown
                    label="DS Scope Reference"
                    width="100%"
                    marginLeft="0"
                    selected={scopeSelection}
                    setSelected={setScopeSelection}
                    options={scopeSpecificData}
                    isRequired={false}
                    singleSelect={false}
                    disabled={!scopeEnabled || isScopeGroup}
                  />
                </div>

                {/* Group */}
                <div className="item-group">
                  <MultiSelectSearchDropdown
                    label={
                      studentGroupsLoading ? (
                        <>
                          DS Group
                          <span
                            style={{
                              fontSize: 12,
                              color: "#666",
                              marginLeft: 6,
                            }}
                          >
                            loading...
                          </span>
                        </>
                      ) : (
                        "DS Group"
                      )
                    }
                    width="100%"
                    marginLeft="0"
                    selected={selectedStudentGroup}
                    setSelected={setSelectedStudentGroup}
                    options={getFilteredStudentGroups().map((g) => ({
                      label: g.label,
                      id: g.id,
                    }))}
                    isRequired={scopeEnabled && isScopeGroup}
                    singleSelect={false}
                    onSearchInputChange={searchStudentGroups}
                    disabled={!scopeEnabled}
                  />
                  {studentGroupsError && (
                    <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                      {studentGroupsError}
                    </div>
                  )}
                </div>

                <div className="item-prov">
                  <DropDown
                    label="Generate Provisional Result"
                    style={{ width: "100%" }}
                    selected={generateProvisionalResult}
                    setSelected={setGenerateProvisionalResult}
                    options={BOOLEAN_OPTIONS}
                    isRequired={false}
                  />
                </div>
                <div className="item-spot">
                  <DropDown
                    label="Provision Spot Registrations"
                    style={{ width: "100%" }}
                    selected={provisionSpotRegistrations}
                    setSelected={setProvisionSpotRegistrations}
                    options={BOOLEAN_OPTIONS}
                    isRequired={false}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ───────────── TEST SCHEDULING ───────────── */}
        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>TEST SCHEDULING</label>
            </div>
            <div className="accordion-btn" onClick={toggleSchedulingVisible}>
              {schedulingVisible ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>

          {schedulingVisible && (
            <div className="accordion-content">
              <div className="grid-container">
                <div className="item1">
                  <InputComponent
                    label="Test Name"
                    style={{ width: "100%" }}
                    value={testNameUserPart}
                    onChange={(e) => setTestNameUserPart(e.target.value)}
                    isRequired={true}
                    disable={false}
                  />
                </div>

                <div className="item2">
                  <InputComponent
                    label="Description"
                    style={{ width: "100%" }}
                    value={testDescription}
                    onChange={(e) => setTestDescription(e.target.value)}
                    isRequired={true}
                    disable={false}
                  />
                </div>

                <div className="item10">
                  <DropDown2
                    label="Number of Sets"
                    style={{ width: "100%" }}
                    selected={numberOfSets}
                    setSelected={setNumberOfSets}
                    options={[1, 2, 3, 4, 5, 6].map((n) => ({
                      id: n,
                      label: String(n),
                    }))}
                    isRequired={false}
                  />
                </div>

                <div className="item-002">
                  <InputComponent
                    label="Test Date Time"
                    className="date-CB2-3"
                    type="datetime-local"
                    id="testDateTime"
                    name="testDateTime"
                    min={getCurrentDateTime()}
                    value={testDateTime || ""}
                    onChange={handleTestDateTimeChange}
                    required
                  />
                </div>

                <div className="item9">
                  <label
                    style={{
                      marginBottom: "6px",
                      display: "block",
                      color: "GrayText",
                    }}
                  >
                    Duration{" "}
                    <span style={{ color: `${Colors.color15}` }}>*</span>
                  </label>
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      placeholder="( In minutes )"
                      type="number"
                      className="time-input2"
                      value={timeMinutes}
                      onChange={handleInputChange}
                      style={{ width: "100%", paddingRight: "50px" }}
                    />
                    <div
                      className="time-display"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "35%",
                        transform: "translateY(-50%)",
                        color: "#888",
                      }}
                    >
                      {time} hr
                    </div>
                  </div>
                </div>

                <div className="item5">
                  <DropDown2
                    label="Shuffle Subjects"
                    style={{ width: "100%" }}
                    selected={shuffleSubjects}
                    setSelected={setShuffleSubjects}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={!numberOfSets || numberOfSets < 2}
                  />
                </div>
                <div className="item8">
                  <DropDown2
                    label="Shuffle Questions"
                    style={{ width: "100%" }}
                    selected={shuffleQuestions}
                    setSelected={setShuffleQuestions}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={!numberOfSets || numberOfSets < 2}
                  />
                </div>
                <div className="item11">
                  <DropDown2
                    label="Shuffle Options"
                    style={{ width: "100%" }}
                    selected={shuffleOptions}
                    setSelected={setShuffleOptions}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={true}
                  />
                </div>

                <div className="item12" style={{ gridColumn: "1/4" }}>
                  <TextEditor
                    templates={testTemplates}
                    value={instructionsHtml}
                    setValue={setInstructionsHtml}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ───────────── MARKING SCHEME ───────────── */}
        <div className="ques-paper-del">
          <div className="personal-header">
            <div className="header">
              <label>MARKING SCHEME</label>
            </div>
            <div className="accordion-btn" onClick={toggleMarkingSchemeVisible}>
              {markingSchemeVisible ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div>
          </div>
          {markingSchemeVisible && (
            <div
              className="accordion-content"
              style={{
                padding: "15px",
                color: `${Colors.color1}`,
                marginBottom: "100px",
              }}
            >
              {paperSubjects.map((subject) =>
                subject.sections.map((section, sectionIdx) => {
                  const key = String.fromCharCode(97 + sectionIdx);
                  const selectedId = selectedMarkingSchemes[key];
                  const scheme = markingSchemeList.find(
                    (ms) => ms.ms_id === selectedId
                  );
                  return (
                    <div
                      className="row-cs"
                      key={`${subject.subject_name}-${section.section_no}`}
                      style={{ marginBottom: "12px", fontSize: "14px" }}
                    >
                      <div className="col-cs" style={{ paddingRight: "10px" }}>
                        <div style={{ marginTop: "10px" }}>
                          {subject.subject_name} - Section{" "}
                          {section.section_name}
                        </div>
                      </div>
                      <div className="col-cs" style={{ paddingRight: "10px" }}>
                        <ReflectDropdown
                          style={{ width: "100%", marginLeft: "1%" }}
                          options={markingSchemeList.map((ms) => ({
                            label: ms.ms_name,
                            id: ms.ms_id,
                          }))}
                          selected={selectedId}
                          setSelected={(val) =>
                            setSelectedMarkingSchemes((prev) => ({
                              ...prev,
                              [key]: val,
                            }))
                          }
                        />
                      </div>
                      <div className="col-cs">
                        <div
                          style={{
                            marginTop: "7px",
                            marginBottom: "4px",
                            color: "gray",
                            marginLeft: "3%",
                          }}
                        >
                          {scheme
                            ? `${scheme.expression} ; ${scheme.ms_desc}`
                            : "—"}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ComputerBasedTestScheduling;


























// import React, { useState, useEffect } from "react";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import DropDown2 from "../../../Pages/CreateQuestionsPaper/TestScheduling/Dropdwon-Shuffle";
// import DropDown3 from "../../../Pages/CreateQuestionsPaper/TestScheduling/Drodpwon-Catch";
// import MultiSelectSearchDropdown from "../../../Pages/CreateQuestionsPaper/SearchDropDown/MultiSelectSearchDropdown";
// import SelectedDropdownValues from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import InputComponent from "../../../Components/Shared/FormInputs/FormInputs";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import Colors from "../../../Constants/Colors";
// import TextEditor from "../../Landing/components/TextEditor";
// import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
// import { useNavigate } from "react-router-dom";

// const BOOLEAN_OPTIONS = [
//   { id: 1, label: "True" },
//   { id: 0, label: "False" },
// ];

// const ComputerBasedTestScheduling = ({
//   dataClient,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");

//   // ── Test information ──────────────────────────────────────────────────────
//   const [courses, setCourses] = useState([]);
//   const [courseOpted, setCourseOpted] = useState("");
//   const [subjects, setSubjects] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedSubjectLabel, setSelectedSubjectLabel] = useState("");
//   const [quesPaperList, setQuesPaperList] = useState([]);
//   const [selectedQuesPaper, setSelectedQuesPaper] = useState(null);
//   const [quesPaperDescription, setQuesPaperDescription] = useState("");
//   const [paperSubjects, setPaperSubjects] = useState([]);

//   // ── External client / flags (all default: not selected) ───────────────────
//   const [isExternalClient, setIsExternalClient] = useState(null);
//   const [clientOptions, setClientOptions] = useState([]); // set this from your API
//   const [selectedClient, setSelectedClient] = useState(null);
//   const [generateProvisionalResult, setGenerateProvisionalResult] =
//     useState(null);
//   const [provisionSpotRegistrations, setProvisionSpotRegistrations] =
//     useState(null);

//   // ── Scope / Scope Reference / Group ───────────────────────────────────────
//   const [scopes, setScopes] = useState([]);
//   const [selectScope, setSelectedScope] = useState(null);
//   const [scopeSpecificData, setScopeSpecificData] = useState([]);
//   const [scopeSelection, setScopeSelection] = useState([]);
//   const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
//   const [allStudentGroups, setAllStudentGroups] = useState([]);
//   const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
//   const [studentGroupsLoading, setStudentGroupsLoading] = useState(false);
//   const [studentGroupsError, setStudentGroupsError] = useState(null);

//   // ── Test scheduling ───────────────────────────────────────────────────────
//   const [testNameUserPart, setTestNameUserPart] = useState("");
//   const [testDescription, setTestDescription] = useState("");
//   const [numberOfSets, setNumberOfSets] = useState(null);
//   const [testDateTime, setTestDateTime] = useState(null);
//   const [time, setTime] = useState("");
//   const [timeMinutes, setTimeMinutes] = useState("");
//   const [shuffleSubjects, setShuffleSubjects] = useState(null);
//   const [shuffleQuestions, setShuffleQuestions] = useState(null);
//   const [shuffleOptions, setShuffleOptions] = useState(null);
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [testTemplates, setTestTemplates] = useState([]);
//   const [serverCurrentTime, setServerCurrentTime] = useState(null);

//   // ── Marking scheme ────────────────────────────────────────────────────────
//   const [markingSchemeList, setMarkingSchemeList] = useState([]);
//   const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState({});

//   // ── Accordions ────────────────────────────────────────────────────────────
//   const [bodyVisible, setBodyVisible] = useState(true);
//   const [schedulingVisible, setSchedulingVisible] = useState(true);
//   const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);

//   // ── Client info (session storage fallback) ────────────────────────────────
//   useEffect(() => {
//     if (dataClient) {
//       const info = dataClient?.client_schema_name?.[6]?.[0];
//       sessionStorage.setItem("user_name", info?.user_name || "");
//       sessionStorage.setItem("clientBranchId", info?.client_branch_id || null);
//       sessionStorage.setItem("clientId", info?.client_id || null);
//     }
//   }, [dataClient]);

//   const userName =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";
//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     null;
//   const clientId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
//     sessionStorage.getItem("clientId") ||
//     null;

//   const courseId = courseOpted
//     ? typeof courseOpted === "object"
//       ? courseOpted.id
//       : courseOpted
//     : null;

//   // Scope / Scope Ref / Group enabled only when External Client = False
//   const isExternalSelected =
//     isExternalClient !== null && isExternalClient !== "";
//   const isExternal = isExternalSelected && Number(isExternalClient) === 1;
//   const scopeEnabled = isExternalSelected && Number(isExternalClient) === 0;

//   const scopeId =
//     selectScope && typeof selectScope === "object"
//       ? selectScope.id
//       : selectScope;
//   const isScopeGroup = Number(scopeId) === 9;

//   // ── Helpers ───────────────────────────────────────────────────────────────
//   const showMessage = (text, img) => {
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{text}</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(img);
//     }
//   };

//   const formatLocal = (d) => {
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     const hours = String(d.getHours()).padStart(2, "0");
//     const mins = String(d.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${mins}`;
//   };

//   const getScopeLabel = (id) => {
//     switch (Number(id)) {
//       case 1:
//         return "Batch";
//       case 2:
//         return "Branch";
//       case 3:
//         return "Zone";
//       case 4:
//         return "City";
//       case 5:
//         return "State";
//       case 7:
//         return "All India (Internal)";
//       case 8:
//         return "All India (Open)";
//       case 9:
//         return "Group";
//       default:
//         return "Scope";
//     }
//   };
//   const scopeLabel = getScopeLabel(scopeId);

//   // ── Server time ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchServerTime = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-current-datetime/`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         const data = await response.json();
//         if (data?.status === 200 && data?.data) {
//           const { current_date, current_time } = data.data;
//           setServerCurrentTime(`${current_date}T${current_time}`);
//         }
//       } catch (error) {
//         console.error("Error fetching server time:", error);
//         setServerCurrentTime(new Date().toISOString());
//       }
//     };
//     fetchServerTime();
//   }, []);

//   // server time + 15 min buffer
//   const getCurrentDateTime = () => {
//     const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
//     base.setMinutes(base.getMinutes() + 15);
//     return formatLocal(base);
//   };

//   // ── Courses ───────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
//         const data = await response.json();
//         setCourses(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//         showMessage(`Error fetching courses: ${error.message}`, ErrorImg);
//       }
//     };
//     fetchCourses();
//   }, []);

//   // ── Scopes list ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchScopes = async () => {
//       try {
//         const response = await fetch(`${FULL_API_BASE_URL}/get-list-of-scopes`, {
//           headers: { accept: "application/json" },
//         });
//         if (!response.ok)
//           throw new Error(`HTTP error! status: ${response.status}`);
//         const data = await response.json();
//         setScopes(data.filter((scope) => scope.status === 1));
//       } catch (error) {
//         console.error("Error fetching scopes:", error);
//         showMessage(`Error fetching Scopes: ${error.message}`, ErrorImg);
//       }
//     };
//     fetchScopes();
//   }, []);

//   // ── Scope reference options ───────────────────────────────────────────────
//   useEffect(() => {
//     const fetchScopeDetails = async () => {
//       if (!scopeEnabled || scopeId === null || scopeId === undefined) {
//         setScopeSpecificData([]);
//         return;
//       }
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-scopes-details-all`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         if (data.status === 200) {
//           let apiData = data.data;
//           if (Number(scopeId) === 1 && courseId) {
//             apiData = apiData.filter((item) => item.course_id === courseId);
//           }
//           let scopeOptions = [];
//           switch (Number(scopeId)) {
//             case 1:
//               scopeOptions = apiData.map((item) => ({
//                 id: item.batch_id,
//                 label: item.batch_name,
//               }));
//               break;
//             case 2:
//               scopeOptions = apiData.map((item) => ({
//                 id: item.branch_id,
//                 label: item.branch_name,
//               }));
//               break;
//             case 3:
//               scopeOptions = apiData.map((item) => ({
//                 id: item.city_zone_id,
//                 label: item.zone_name,
//               }));
//               break;
//             case 4:
//               scopeOptions = apiData.map((item) => ({
//                 id: item.city_id,
//                 label: item.city_name,
//               }));
//               break;
//             case 5:
//               scopeOptions = apiData.map((item) => ({
//                 id: item.state_id,
//                 label: item.state_name,
//               }));
//               break;
//             case 7:
//             case 8:
//               scopeOptions = [{ id: 1, label: "All India" }];
//               break;
//             default:
//               scopeOptions = [];
//           }
//           scopeOptions = Array.from(
//             new Map(scopeOptions.map((opt) => [opt.id, opt])).values()
//           );
//           setScopeSpecificData(scopeOptions);
//         } else {
//           setScopeSpecificData([]);
//         }
//       } catch (error) {
//         console.error("Error fetching scope details:", error);
//         setScopeSpecificData([]);
//       }
//     };
//     fetchScopeDetails();
//   }, [scopeId, courseId, scopeEnabled]);

//   // ── Student groups ────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchStudentGroups = async () => {
//       if (!clientBranchId) return;
//       try {
//         setStudentGroupsLoading(true);
//         setStudentGroupsError(null);
//         const resp = await fetch(
//           `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         if (resp.status === 401 || resp.status === 403) {
//           setStudentGroupsError("Not authenticated. Please login.");
//           setStudentGroupsOptions([]);
//           setAllStudentGroups([]);
//           return;
//         }
//         const json = await resp.json();
//         if (
//           json &&
//           (json.status === "200" || json.status === 200) &&
//           Array.isArray(json.data)
//         ) {
//           const options = json.data.map((group) => ({
//             id: group.student_group_id,
//             label: group.student_group_name,
//             session_id: group.session_id || "",
//             course_id: group.course_id || "",
//           }));
//           setStudentGroupsOptions(options);
//           setAllStudentGroups(options);
//         } else {
//           setStudentGroupsOptions([]);
//           setAllStudentGroups([]);
//         }
//       } catch (err) {
//         console.error("Error fetching student groups:", err);
//         setStudentGroupsError(err.message || "Error");
//         setStudentGroupsOptions([]);
//         setAllStudentGroups([]);
//       } finally {
//         setStudentGroupsLoading(false);
//       }
//     };
//     fetchStudentGroups();
//   }, [clientBranchId, accessToken]);

//   useEffect(() => {
//     setSelectedStudentGroup([]);
//   }, [courseId]);

//   const searchStudentGroups = (searchKey) => {
//     let filtered = allStudentGroups;
//     if (courseId) filtered = filtered.filter((g) => g.course_id === courseId);
//     if (searchKey && searchKey.trim() !== "")
//       filtered = filtered.filter((g) =>
//         g.label.toLowerCase().includes(searchKey.toLowerCase())
//       );
//     setStudentGroupsOptions(filtered);
//   };

//   const getFilteredStudentGroups = () => {
//     if (!courseId) return studentGroupsOptions;
//     return studentGroupsOptions.filter((g) => g.course_id === courseId);
//   };

//   // Group scope → scope reference not applicable
//   useEffect(() => {
//     if (isScopeGroup) setScopeSelection([]);
//   }, [isScopeGroup]);

//   // External client = true / not selected → clear scope, scope ref, group
//   useEffect(() => {
//     if (!scopeEnabled) {
//       setSelectedScope(null);
//       setScopeSelection([]);
//       setSelectedStudentGroup([]);
//     }
//   }, [scopeEnabled]);

//   // Clear client when External Client is not True
//   useEffect(() => {
//     if (!isExternal) setSelectedClient(null);
//   }, [isExternal]);

//   // ── Client list (external clients) ────────────────────────────────────────
//   useEffect(() => {
//     const fetchClients = async () => {
//       try {
//         const response = await fetch(`${FULL_API_BASE_URL}/get-cbt-client-list/`, {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         if (!response.ok)
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         const result = await response.json();
//         if (result.status === 200 && Array.isArray(result.data)) {
//           // id = client_name (unique, since some client_id values are null)
//           setClientOptions(
//             result.data.map((c) => ({
//               id: c.client_name,
//               label: c.client_name,
//               client_id: c.client_id,
//             }))
//           );
//         } else {
//           setClientOptions([]);
//         }
//       } catch (error) {
//         console.error("Error fetching client list:", error);
//         showMessage(`Error fetching client list: ${error.message}`, ErrorImg);
//       }
//     };
//     fetchClients();
//   }, []);

//   // ── Subjects by course ────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchSubjects = async () => {
//       setSubjects([]);
//       setSelectedSubject(null);
//       setSelectedSubjectLabel("");
//       setSelectedQuesPaper(null);
//       if (!courseId) return;
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${courseId}`
//         );
//         const data = await response.json();
//         setSubjects(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error("Error fetching subjects:", error);
//         showMessage(`Error fetching subjects: ${error.message}`, ErrorImg);
//       }
//     };
//     fetchSubjects();
//   }, [courseId]);

//   // ── Question paper list ───────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchQuestionPaperList = async () => {
//       setQuesPaperList([]);
//       if (!clientBranchId || !courseId) return;
//       try {
//         const response = await fetch(
//          `${FULL_API_BASE_URL}/get-ques-paper-list/?branch_id=${clientBranchId}&course_id=${courseId}&class_id=10`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         if (!response.ok)
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         const result = await response.json();
//         if (result.status === 200) setQuesPaperList(result.data);
//       } catch (error) {
//         console.error("Error fetching question paper list:", error);
//       }
//     };
//     fetchQuestionPaperList();
//   }, [clientBranchId, courseId]);

//   // ── Marking schemes ───────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchMarkingSchemes = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
//           { headers: { accept: "application/json" } }
//         );
//         const result = await response.json();
//         if (result.status_code === 200 || result.status === "success")
//           setMarkingSchemeList(result.data);
//       } catch (error) {
//         console.error("Error fetching marking schemes:", error);
//       }
//     };
//     fetchMarkingSchemes();
//   }, []);

//   // ── Instruction templates ─────────────────────────────────────────────────
//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     const fetchTestTemplates = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-test-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         if (!response.ok)
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         setTestTemplates(await response.json());
//       } catch (error) {
//         console.error("Error fetching test templates:", error);
//       }
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   // ── Selected question paper → description + subjects/sections ─────────────
//   useEffect(() => {
//     const matchingPaper =
//       selectedQuesPaper !== null
//         ? quesPaperList.find(
//             (paper) => Number(paper.ques_paper_id) === Number(selectedQuesPaper)
//           )
//         : null;

//     if (!matchingPaper) {
//       setQuesPaperDescription("");
//       setPaperSubjects([]);
//       setSelectedMarkingSchemes({});
//       return;
//     }

//     setQuesPaperDescription(matchingPaper.description || "");
//     const subjectsWithSections = Array.isArray(matchingPaper.subjects)
//       ? matchingPaper.subjects.map((subject) => ({
//           subject_id: subject.subject_id,
//           subject_name: subject.subject_name,
//           sections:
//             Array.isArray(subject.sections) && subject.sections.length > 0
//               ? subject.sections
//               : [{ section_no: 1, section_name: "Section 1" }],
//         }))
//       : [];
//     setPaperSubjects(subjectsWithSections);
//     setSelectedMarkingSchemes({});
//   }, [selectedQuesPaper, quesPaperList]);

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const handleInputChange = (e) => {
//     const minutes = e.target.value;
//     setTime(minutes ? (minutes / 60).toFixed(2) : "");
//     setTimeMinutes(minutes);
//   };

//   const handleTestDateTimeChange = (e) => setTestDateTime(e.target.value);

//   // ── Save ──────────────────────────────────────────────────────────────────
//   const handleSave = async () => {
//     const minAllowed = getCurrentDateTime();

//     if (!courseId) return showMessage("Please select a Course.", ErrorImg);
//     if (!selectedSubject)
//       return showMessage("Please select a Subject.", ErrorImg);
//     if (!selectedQuesPaper)
//       return showMessage(
//         "Question Paper must be selected. Please choose a valid question paper.",
//         ErrorImg
//       );

//     if (!isExternalSelected)
//       return showMessage("Please select External Client.", ErrorImg);

//     if (isExternal && !selectedClient)
//       return showMessage(
//         "Please select a Client Name for an external client.",
//         ErrorImg
//       );

//     // Scope / Scope Ref / Group validation (only when enabled)
//     if (scopeEnabled) {
//       const scopeSelectionFilled = Array.isArray(scopeSelection)
//         ? scopeSelection.length > 0
//         : !!scopeSelection;
//       const studentGroupFilled = Array.isArray(selectedStudentGroup)
//         ? selectedStudentGroup.length > 0
//         : !!selectedStudentGroup;

//       if (isScopeGroup) {
//         if (!studentGroupFilled)
//           return showMessage(
//             'Please select at least one Student Group when Scope is set to "Group".',
//             ErrorImg
//           );
//       } else if (!scopeSelectionFilled && !studentGroupFilled) {
//         return showMessage(
//           "Please select at least one Scope Reference OR a Student Group. Both cannot be empty.",
//           ErrorImg
//         );
//       }
//     }

//     if (!testDateTime)
//       return showMessage("Please select a Test Date Time.", ErrorImg);
//     if (testDateTime < minAllowed)
//       return showMessage(
//         "Test date time must be at least 15 minutes from current time. Please correct it before saving.",
//         ErrorImg
//       );

//     const durationMins = parseInt(timeMinutes, 10);
//     if (!durationMins || durationMins <= 0)
//       return showMessage(
//         "Please enter a valid Duration (in minutes).",
//         ErrorImg
//       );

//     const missingFields = [];
//     if (!testNameUserPart.trim()) missingFields.push("Test Name");
//     if (!testDescription.trim()) missingFields.push("Description");
//     if (!instructionsHtml.trim()) missingFields.push("Instructions");
//     if (missingFields.length > 0)
//       return showMessage(
//         `Please fill in all required fields: ${missingFields.join(", ")}.`,
//         ErrorImg
//       );

//     const subjectsPayload = paperSubjects.map((subject) => {
//       const marking_scheme = {};
//       subject.sections.forEach((section, idx) => {
//         const key = String.fromCharCode(97 + idx);
//         marking_scheme[`ms_id_sec_${key}`] = selectedMarkingSchemes[key] || 0;
//       });
//       return {
//         subject_id: subject.subject_id,
//         subject_name: subject.subject_name,
//         marking_scheme: [marking_scheme],
//       };
//     });

//     // end = test date time + duration (kept for backward compatible API)
//     const testEnd = formatLocal(
//       new Date(new Date(testDateTime).getTime() + durationMins * 60 * 1000)
//     );

//     const finalScopeId = scopeEnabled ? Number(scopeId) || 0 : 0;
//     const batchIds =
//       scopeEnabled && finalScopeId === 1
//         ? scopeSelection.map((s) => (typeof s === "object" ? s.id : s))
//         : [];
//     const studentGroupIds = scopeEnabled
//       ? Array.isArray(selectedStudentGroup)
//         ? selectedStudentGroup
//         : selectedStudentGroup
//         ? [selectedStudentGroup]
//         : []
//       : [];

//     const body = {
//       request: {
//         ts_id: null,
//         ques_paper_scope_id: finalScopeId,
//         ques_paper_id: selectedQuesPaper || 0,
//         test_name: testNameUserPart,
//         test_desc: testDescription || "",
//         test_date_time: testDateTime,
//         test_window_start: testDateTime,
//         test_window_end: testEnd,
//         duration_mins: durationMins,
//         no_of_sets: numberOfSets || 1,
//         test_mode: 1,
//         test_coordnator_emp_id: 0,
//         client_id: clientId || 0,
//         client_branch_id: clientBranchId || 0,
//         created_by: userName || "",
//         instructions_html: instructionsHtml || "",
//         scope_ref_id_list:
//           scopeEnabled && !isScopeGroup ? scopeSelection : [],
//         student_group_id_list: studentGroupIds,
//         subjects: subjectsPayload,
//         is_external_client: isExternal,
//        external_client_id: isExternal
//           ? clientOptions.find((c) => c.id === selectedClient)?.client_id ??
//             null
//           : null,
//         client_name: isExternal ? selectedClient || "" : "",
//         generate_provisional_result: Boolean(Number(generateProvisionalResult)),
//         provision_spot_registrations: Boolean(
//           Number(provisionSpotRegistrations)
//         ),
//       },
//       payload: {
//         user_name: userName || "",
//         client_branch_id: clientBranchId ? Number(clientBranchId) : 0,
//         screen_event_id: 74,
//         screen_id: 76,
//         student_id: null,
//         batch_id: batchIds.length ? batchIds : null,
//         subject_id: selectedSubject ? [selectedSubject] : null,
//         class_id: null,
//         course_id: courseId ? [courseId] : null,
//         session_id: null,
//         student_group_id: studentGroupIds.length ? studentGroupIds : null,
//       },
//     };

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/create-test-schedule-v1/?shuffle_ques=${!!shuffleQuestions}&shuffle_subject=${!!shuffleSubjects}&shuffle_option=${!!shuffleOptions}`,
//         {
//           method: "POST",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(body),
//         }
//       );
//       if (!response.ok)
//         throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       if (data.status === 400) {
//         showMessage(data.message, ErrorImg);
//         return;
//       }
//       showMessage(
//         data.message || "Test schedule created successfully!",
//         SuccessImg
//       );
//       setTimeout(() => window.location.reload(), 1000);
//     } catch (error) {
//       showMessage(`Error creating test schedule: ${error.message}`, ErrorImg);
//     }
//   };

//   const toggleBodyVisible = () => setBodyVisible(!bodyVisible);
//   const toggleSchedulingVisible = () =>
//     setSchedulingVisible(!schedulingVisible);
//   const toggleMarkingSchemeVisible = () =>
//     setMarkingSchemeVisible(!markingSchemeVisible);

//   // Question papers filtered by the chosen subject
//   const filteredQuesPapers = quesPaperList.filter(
//     (qp) =>
//       !selectedSubject ||
//       !Array.isArray(qp.subjects) ||
//       qp.subjects.some((s) => Number(s.subject_id) === Number(selectedSubject))
//   );

//   return (
//     <>
//       <div className="create-role-container">
//         <div className="create-role-container-ques-paper-del">
//           <span className="create-role-heading">CBT Scheduling</span>
//           <div className="cr-header-btn-container">
//             <button
//               className="cr-cancel-btn"
//               onClick={() => navigate(`/cbt_dashboard`)}
//             >
//               CANCEL
//             </button>
//             <button className="cr-create-btn" onClick={handleSave}>
//               SAVE
//             </button>
//           </div>
//         </div>

//         {/* ───────────── TEST INFORMATION ───────────── */}
//         <div className="ques-paper-del">
//           <div className="personal-header">
//             <div className="header">
//               <label>TEST INFORMATION</label>
//             </div>
//             <div className="accordion-btn" onClick={toggleBodyVisible}>
//               {bodyVisible ? (
//                 <div className="minus"></div>
//               ) : (
//                 <div className="plus">+</div>
//               )}
//             </div>
//           </div>
//           {bodyVisible && (
//             <div className="accordion-content">
//               {/* 3 fields per row:
//                   Row 1: Course, Subject, Question Paper Name
//                   Row 2: Question Paper Description, External Client, Client Name
//                   Row 3: Scope, Scope Reference, Group (enabled only if External Client = False)
//                   Row 4: Generate Provisional Result, Provision Spot Registrations */}
//               <div
//                 className="grid-container"
//                 style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
//               >
//                 <div className="item3">
//                   <SelectedDropdownValues
//                     label="Course"
//                     style={{ width: "100%" }}
//                     setSelected={setCourseOpted}
//                     selected={courseOpted}
//                     options={courses.map((course) => ({
//                       label: course.course_name,
//                       id: course.course_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="item-subject">
//                   <DropDown
//                     label="Subject"
//                     style={{ width: "100%" }}
//                     selected={selectedSubject}
//                     setSelected={setSelectedSubject}
//                     selectedLabel={selectedSubjectLabel}
//                     setSelectedLabel={setSelectedSubjectLabel}
//                     options={subjects.map((subject) => ({
//                       label: subject.subject_name,
//                       id: subject.subject_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="item-001">
//                   <DropDown
//                     label="Question Paper Name"
//                     style={{ width: "100%" }}
//                     selected={selectedQuesPaper}
//                     setSelected={setSelectedQuesPaper}
//                     options={filteredQuesPapers.map((qp) => ({
//                       label: qp.ques_paper_name,
//                       id: qp.ques_paper_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="item6">
//                   <InputComponent
//                     label="Question Paper Description"
//                     style={{ width: "100%" }}
//                     value={quesPaperDescription}
//                     isRequired={false}
//                     disable={true}
//                   />
//                 </div>

//                 <div className="item-ext">
//                   <DropDown
//                     label="External Client"
//                     style={{ width: "100%" }}
//                     selected={isExternalClient}
//                     setSelected={setIsExternalClient}
//                     options={BOOLEAN_OPTIONS}
//                     isRequired={true}
//                   />
//                 </div>

//                 <div
//                   className="item-client"
//                   style={{
//                     opacity: isExternal ? 1 : 0.5,
//                     pointerEvents: isExternal ? "auto" : "none",
//                   }}
//                 >
//                   <DropDown
//                     label="Client Name"
//                     style={{ width: "100%" }}
//                     selected={selectedClient}
//                     setSelected={setSelectedClient}
//                     options={clientOptions}
//                     isRequired={isExternal}
//                   />
//                 </div>

//                 {/* Scope */}
//                 <div
//                   className="item-scope"
//                   style={{
//                     opacity: scopeEnabled ? 1 : 0.5,
//                     pointerEvents: scopeEnabled ? "auto" : "none",
//                   }}
//                 >
//                   <DropDown3
//                     label=" DS Scope"
//                     style={{ width: "100%" }}
//                     selected={selectScope}
//                     setSelected={(value) => {
//                       setSelectedScope(value);
//                       setScopeSelection([]);
//                     }}
//                     options={scopes.map((scope) => ({
//                       label: scope.ques_paper_scope_desc,
//                       id: scope.ques_paper_scope_id,
//                     }))}
//                     isRequired={false}
//                     disabled={!scopeEnabled}
//                   />
//                 </div>

//                 {/* Scope Reference */}
//                 <div className="item-scope-ref">
//                   <MultiSelectSearchDropdown
//                     label="DS Scope Reference"
//                     width="100%"
//                     marginLeft="0"
//                     selected={scopeSelection}
//                     setSelected={setScopeSelection}
//                     options={scopeSpecificData}
//                     isRequired={false}
//                     singleSelect={false}
//                     disabled={!scopeEnabled || isScopeGroup}
//                   />
//                 </div>

//                 {/* Group */}
//                 <div className="item-group">
//                   <MultiSelectSearchDropdown
//                     label={
//                       studentGroupsLoading ? (
//                         <>
//                           DS Group
//                           <span
//                             style={{
//                               fontSize: 12,
//                               color: "#666",
//                               marginLeft: 6,
//                             }}
//                           >
//                             loading...
//                           </span>
//                         </>
//                       ) : (
//                         "DS Group"
//                       )
//                     }
//                     width="100%"
//                     marginLeft="0"
//                     selected={selectedStudentGroup}
//                     setSelected={setSelectedStudentGroup}
//                     options={getFilteredStudentGroups().map((g) => ({
//                       label: g.label,
//                       id: g.id,
//                     }))}
//                     isRequired={scopeEnabled && isScopeGroup}
//                     singleSelect={false}
//                     onSearchInputChange={searchStudentGroups}
//                     disabled={!scopeEnabled}
//                   />
//                   {studentGroupsError && (
//                     <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
//                       {studentGroupsError}
//                     </div>
//                   )}
//                 </div>

//                 <div className="item-prov">
//                   <DropDown
//                     label="Generate Provisional Result"
//                     style={{ width: "100%" }}
//                     selected={generateProvisionalResult}
//                     setSelected={setGenerateProvisionalResult}
//                     options={BOOLEAN_OPTIONS}
//                     isRequired={false}
//                   />
//                 </div>
//                 <div className="item-spot">
//                   <DropDown
//                     label="Provision Spot Registrations"
//                     style={{ width: "100%" }}
//                     selected={provisionSpotRegistrations}
//                     setSelected={setProvisionSpotRegistrations}
//                     options={BOOLEAN_OPTIONS}
//                     isRequired={false}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ───────────── TEST SCHEDULING ───────────── */}
//         <div className="ques-paper-del">
//           <div className="personal-header">
//             <div className="header">
//               <label>TEST SCHEDULING</label>
//             </div>
//             <div className="accordion-btn" onClick={toggleSchedulingVisible}>
//               {schedulingVisible ? (
//                 <div className="minus"></div>
//               ) : (
//                 <div className="plus">+</div>
//               )}
//             </div>
//           </div>

//           {schedulingVisible && (
//             <div className="accordion-content">
//               <div className="grid-container">
//                 <div className="item1">
//                   <InputComponent
//                     label="Test Name"
//                     style={{ width: "100%" }}
//                     value={testNameUserPart}
//                     onChange={(e) => setTestNameUserPart(e.target.value)}
//                     isRequired={true}
//                     disable={false}
//                   />
//                 </div>

//                 <div className="item2">
//                   <InputComponent
//                     label="Description"
//                     style={{ width: "100%" }}
//                     value={testDescription}
//                     onChange={(e) => setTestDescription(e.target.value)}
//                     isRequired={true}
//                     disable={false}
//                   />
//                 </div>

//                 <div className="item10">
//                   <DropDown2
//                     label="Number of Sets"
//                     style={{ width: "100%" }}
//                     selected={numberOfSets}
//                     setSelected={setNumberOfSets}
//                     options={[1, 2, 3, 4, 5, 6].map((n) => ({
//                       id: n,
//                       label: String(n),
//                     }))}
//                     isRequired={false}
//                   />
//                 </div>

//                 <div className="item-002">
//                   <InputComponent
//                     label="Test Date Time"
//                     className="date-CB2-3"
//                     type="datetime-local"
//                     id="testDateTime"
//                     name="testDateTime"
//                     min={getCurrentDateTime()}
//                     value={testDateTime || ""}
//                     onChange={handleTestDateTimeChange}
//                     required
//                   />
//                 </div>

//                 <div className="item9">
//                   <label
//                     style={{
//                       marginBottom: "6px",
//                       display: "block",
//                       color: "GrayText",
//                     }}
//                   >
//                     Duration{" "}
//                     <span style={{ color: `${Colors.color15}` }}>*</span>
//                   </label>
//                   <div style={{ position: "relative", width: "100%" }}>
//                     <input
//                       placeholder="( In minutes )"
//                       type="number"
//                       className="time-input2"
//                       value={timeMinutes}
//                       onChange={handleInputChange}
//                       style={{ width: "100%", paddingRight: "50px" }}
//                     />
//                     <div
//                       className="time-display"
//                       style={{
//                         position: "absolute",
//                         right: "10px",
//                         top: "35%",
//                         transform: "translateY(-50%)",
//                         color: "#888",
//                       }}
//                     >
//                       {time} hr
//                     </div>
//                   </div>
//                 </div>

//                 <div className="item5">
//                   <DropDown2
//                     label="Shuffle Subjects"
//                     style={{ width: "100%" }}
//                     selected={shuffleSubjects}
//                     setSelected={setShuffleSubjects}
//                     options={[
//                       { id: 1, label: "Yes" },
//                       { id: 0, label: "No" },
//                     ]}
//                     isRequired={false}
//                     disabled={!numberOfSets || numberOfSets < 2}
//                   />
//                 </div>
//                 <div className="item8">
//                   <DropDown2
//                     label="Shuffle Questions"
//                     style={{ width: "100%" }}
//                     selected={shuffleQuestions}
//                     setSelected={setShuffleQuestions}
//                     options={[
//                       { id: 1, label: "Yes" },
//                       { id: 0, label: "No" },
//                     ]}
//                     isRequired={false}
//                     disabled={!numberOfSets || numberOfSets < 2}
//                   />
//                 </div>
//                 <div className="item11">
//                   <DropDown2
//                     label="Shuffle Options"
//                     style={{ width: "100%" }}
//                     selected={shuffleOptions}
//                     setSelected={setShuffleOptions}
//                     options={[
//                       { id: 1, label: "Yes" },
//                       { id: 0, label: "No" },
//                     ]}
//                     isRequired={false}
//                     disabled={true}
//                   />
//                 </div>

//                 <div className="item12" style={{ gridColumn: "1/4" }}>
//                   <TextEditor
//                     templates={testTemplates}
//                     value={instructionsHtml}
//                     setValue={setInstructionsHtml}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ───────────── MARKING SCHEME ───────────── */}
//         <div className="ques-paper-del">
//           <div className="personal-header">
//             <div className="header">
//               <label>MARKING SCHEME</label>
//             </div>
//             <div className="accordion-btn" onClick={toggleMarkingSchemeVisible}>
//               {markingSchemeVisible ? (
//                 <div className="minus"></div>
//               ) : (
//                 <div className="plus">+</div>
//               )}
//             </div>
//           </div>
//           {markingSchemeVisible && (
//             <div
//               className="accordion-content"
//               style={{
//                 padding: "15px",
//                 color: `${Colors.color1}`,
//                 marginBottom: "100px",
//               }}
//             >
//               {paperSubjects.map((subject) =>
//                 subject.sections.map((section, sectionIdx) => {
//                   const key = String.fromCharCode(97 + sectionIdx);
//                   const selectedId = selectedMarkingSchemes[key];
//                   const scheme = markingSchemeList.find(
//                     (ms) => ms.ms_id === selectedId
//                   );
//                   return (
//                     <div
//                       className="row-cs"
//                       key={`${subject.subject_name}-${section.section_no}`}
//                       style={{ marginBottom: "12px", fontSize: "14px" }}
//                     >
//                       <div className="col-cs" style={{ paddingRight: "10px" }}>
//                         <div style={{ marginTop: "10px" }}>
//                           {subject.subject_name} - Section{" "}
//                           {section.section_name}
//                         </div>
//                       </div>
//                       <div className="col-cs" style={{ paddingRight: "10px" }}>
//                         <ReflectDropdown
//                           style={{ width: "100%", marginLeft: "1%" }}
//                           options={markingSchemeList.map((ms) => ({
//                             label: ms.ms_name,
//                             id: ms.ms_id,
//                           }))}
//                           selected={selectedId}
//                           setSelected={(val) =>
//                             setSelectedMarkingSchemes((prev) => ({
//                               ...prev,
//                               [key]: val,
//                             }))
//                           }
//                         />
//                       </div>
//                       <div className="col-cs">
//                         <div
//                           style={{
//                             marginTop: "7px",
//                             marginBottom: "4px",
//                             color: "gray",
//                             marginLeft: "3%",
//                           }}
//                         >
//                           {scheme
//                             ? `${scheme.expression} ; ${scheme.ms_desc}`
//                             : "—"}
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default ComputerBasedTestScheduling;
